<template>
  <q-layout class="unauthorizedBackground">
    <q-page-container>
      <q-page>
        <SignOutButton />

        <div style="margin-top: 10px; margin-left: 70px;">
          <HomeLogo />
        </div>

        <div class="centered"><img src="../../assets/unauthorized.png">
          <div class="unauthorizedHeader">No authorization found.</div>
          <div class="unauthorizedBody">This page is not publicly available.</div>
          <div class="unauthorizedBody">Please login with an admin account.</div>
          <q-btn
            @click="handleHome"
            label="RETURN HOME"
            unelevated
            no-caps
            text-color="white"
            class="text-bold returnButton"
          />
        </div>
      </q-page>
    </q-page-container>

    <AppFooter />
  </q-layout>
</template>

<script>
import SignOutButton from "../admin/SignOutButton.vue";
import HomeLogo, { handleHome } from "./HomeLogo.vue";
import AppFooter from "./AppFooter.vue";

export default {
  name: "UnAuthorized",
  components: {
    SignOutButton,
    HomeLogo,
    AppFooter
  },
  setup() {
    return {
      //functions
      handleHome
    };
  }
};
</script>

<style scoped>
.unauthorizedBackground {
  background: white;
}
.unauthorizedHeader {
  font-size: 57px;
  font-weight: bold;
  color: #0067C1;
}
.unauthorizedBody {
  font-size: 32px;
  color: #0067C1;
}
.returnButton {
  font-size: 24px;
  padding: 0 40px;
  background: linear-gradient(to left, #0316C2 0%, #1131C5 0%, #2F6CCC 100%, #3374CD 100%, #3B83CF 100%);
  border: 1px solid #CECECE;
  margin-top: 25px;
}
</style>